import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.errorContainer}>
          <div style={styles.errorContent}>
            <img
              src="https://cdn-icons-png.flaticon.com/512/753/753345.png"
              alt="Broken robot"
              style={styles.errorImage}
            />
            <h2 style={styles.errorTitle}>Oops! Something went wrong.</h2>
            <p style={styles.errorMessage}>
              We've encountered an unexpected error. Our team has been notified.
            </p>
            <button
              style={styles.retryButton}
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>

            {process.env.NODE_ENV === 'development' && (
              <details style={styles.errorDetails}>
                <summary style={styles.detailsSummary}>Error Details</summary>
                <pre style={styles.errorPre}>
                  {this.state.error && this.state?.error?.toString()}
                  {'\n\n'}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px',
    textAlign: 'center',
  },
  errorContent: {
    maxWidth: '500px',
    padding: '30px',
    borderRadius: '8px',
    backgroundColor: 'white',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  errorImage: {
    width: '100px',
    height: '100px',
    marginBottom: '20px',
    opacity: '0.8',
  },
  errorTitle: {
    color: '#dc3545',
    marginBottom: '15px',
    fontSize: '24px',
  },
  errorMessage: {
    color: '#6c757d',
    marginBottom: '20px',
    fontSize: '16px',
  },
  retryButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.3s',
  },
  errorDetails: {
    marginTop: '20px',
    textAlign: 'left',
  },
  detailsSummary: {
    color: '#6c757d',
    cursor: 'pointer',
    marginBottom: '10px',
  },
  errorPre: {
    backgroundColor: '#f8f9fa',
    padding: '15px',
    borderRadius: '4px',
    overflowX: 'auto',
    fontSize: '14px',
    color: '#dc3545',
  },
};

export default ErrorBoundary;